<div class ="flyOut-wrapper">
    <div class ="outerbox-wrapper">
        <span class="triangle-top"></span>   
        <div class="content-wrapper">
            <div  *ngFor="let deviceProperty of deviceProperties" class="inner-wrapper">
                <span class ="textClass">{{deviceProperty.key | transloco}}</span>
                <span class ="textClass">{{deviceProperty.value}}</span>
            </div>
          <!-- <div class="inner-wrapper">
            <span *ngIf="rsaVersion>='0.3'" class ="textClass">{{softwareVersionText | transloco}}</span>
            <span *ngIf="rsaVersion>='0.3'" class ="textClass">{{softwareVersion}}</span>
          </div> -->
           
        </div>
        
    </div>
</div>
